import React, {useEffect} from 'react';
import {Form, Input, Modal, Select} from 'antd';
import {CreateCheckJobDataSourceInput} from '../graphql/types/BcpCheckJobTypes';

interface BcpDataSourceModalProps {
    visible: boolean;
    initialData?: CreateCheckJobDataSourceInput;
    editIndex?: number;
    onConfirm: (data: CreateCheckJobDataSourceInput, index?: number) => void;
    onCancel: () => void;
}

const BcpDataSourceModal: React.FC<BcpDataSourceModalProps> = ({
    visible,
    initialData,
    editIndex,
    onConfirm,
    onCancel,
}) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            if (initialData) {
                let databaseName = '';
                try {
                    const cfg = JSON.parse(initialData.config || '{}');
                    databaseName = cfg.database || '';
                } catch {}
                form.setFieldsValue({
                    databaseName,
                    tableName: initialData.tableName,
                    useFields: initialData.useFields,
                    groupRule: initialData.groupRule,
                    filterRule: initialData.filterRule,
                    mustExist: initialData.mustExist ?? true,
                });
            } else {
                form.resetFields();
                form.setFieldValue('mustExist', true);
            }
        }
    }, [visible, initialData, form]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            const data: CreateCheckJobDataSourceInput = {
                type: 1,
                config: values.databaseName ? JSON.stringify({database: values.databaseName}) : undefined,
                tableName: values.tableName || undefined,
                useFields: values.useFields || undefined,
                groupRule: values.groupRule || undefined,
                filterRule: values.filterRule || undefined,
                mustExist: values.mustExist ?? true,
            };
            onConfirm(data, editIndex);
        } catch {
            // validation error, inline messages already shown
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    return (
        <Modal
            title={editIndex !== undefined ? '编辑数据源' : '添加数据源'}
            open={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="确认"
            cancelText="取消"
            width={600}
            destroyOnClose
        >
            <Form form={form} layout="vertical">
                <Form.Item label="数据源类型">
                    <Input value="数据库" disabled />
                </Form.Item>
                <Form.Item
                    label="必须存在"
                    name="mustExist"
                    rules={[{required: true, message: '请选择是否必须存在'}]}
                >
                    <Select
                        options={[
                            {label: '是', value: true},
                            {label: '否', value: false},
                        ]}
                    />
                </Form.Item>
                <Form.Item
                    label="数据库名"
                    name="databaseName"
                    rules={[{required: true, message: '请输入数据库名'}]}
                >
                    <Input placeholder="请输入数据库名" />
                </Form.Item>
                <Form.Item
                    label="表名"
                    name="tableName"
                    rules={[{required: true, message: '请输入表名'}]}
                >
                    <Input placeholder="请输入表名" />
                </Form.Item>
                <Form.Item
                    label="使用字段"
                    name="useFields"
                    rules={[{required: true, message: '请输入使用字段'}]}
                >
                    <Input.TextArea rows={2} placeholder="请输入使用字段" />
                </Form.Item>
                <Form.Item
                    label="分组规则"
                    name="groupRule"
                    rules={[{required: true, message: '请输入分组规则'}]}
                >
                    <Input.TextArea rows={2} placeholder="请输入分组规则" />
                </Form.Item>
                <Form.Item
                    label="过滤规则"
                    name="filterRule"
                    rules={[{required: true, message: '请输入过滤规则'}]}
                >
                    <Input.TextArea rows={2} placeholder="请输入过滤规则" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default BcpDataSourceModal;
